import { FunctionComponent } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../FullscreenLoader/FullscreenLoader';
import { shouldCompleteFirstLogin } from '../../utils/utils';

interface FlowRoutePropTypes {
  [key: string]: any;
  component?: FunctionComponent<RouteComponentProps>;
  path: string;
  children?: JSX.Element;
  flow: string;
}

const FlowRouteComponent = ({ component: Component, path, children, flow, ...rest }: FlowRoutePropTypes) => {
  const { currentUser, userDataFmt, userClaims } = useFirebase();

  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        if (!currentUser) return <Redirect to={`/`} />;
        if (!userDataFmt) return <FullscreenLoader />;
        if (userClaims.flow != flow && !userDataFmt.admin) return <Redirect to={`/`} />;
        if (shouldCompleteFirstLogin(userDataFmt)) return <Redirect to={'/first-login'} />;
        if (Component) return <Component {...props} />;
        return <>{children}</>;
      }}
    />
  );
};

export { FlowRouteComponent as FlowRoute };
